import { fetchBasicJsonPostJson } from '@/script/common';

export default {
    getPatientHistoryData: (page, itemsPerPage, filter, signal) => {
        let parameters = {
            page: page,
            pageSize: itemsPerPage,
            ...filter
        };
        return fetchBasicJsonPostJson('/Patient/GetPatientHistoryDataTableData', {
            data: parameters,
            signal
        });
    }
};
